export const BOOKING_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const BOOKING_STATUS_LABEL = {
  [BOOKING_STATUS.PENDING]: "Đang chờ",
  [BOOKING_STATUS.COMPLETED]: "Đã hoàn thành",
  [BOOKING_STATUS.CANCELLED]: "Đã hủy",
};

export const BOOKING_TYPE = {
  SINGLE: "single",
  COURSE: "course",
};

export const BOOKING_TYPE_LABEL = {
  [BOOKING_TYPE.SINGLE]: "Buổi lẻ",
  [BOOKING_TYPE.COURSE]: "Buổi liệu trình",
};
